import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'
import { isBlankOrUnknown } from '@/utils/validators'

// Fetch location data from Cloudflare worker, with ipstack fallback
export async function fetchLocation() {
  try {
    const response = await axios.get(ENDPOINTS.LOCATION_WORKER)
    const { ip, city, region, zip } = response.data || {}

    const result = {
      ip: ip || 'Unknown',
      city: city || 'Unknown',
      state: region || 'Unknown',
      zip: zip || 'Unknown'
    }

    // If worker returned blanks/Unknowns, try ipstack fallback
    if (isBlankOrUnknown(result.city) || isBlankOrUnknown(result.state)) {
      const fallback = await ipstackFallback()
      if (fallback) {
        return {
          ip: result.ip !== 'Unknown' ? result.ip : fallback.ip,
          city: fallback.city || result.city,
          state: fallback.state || result.state,
          zip: fallback.zip || result.zip
        }
      }
    }

    return result
  } catch (error) {
    console.error('Worker location fetch failed:', error)
    // On failure, try ipstack fallback
    const fallback = await ipstackFallback()
    return fallback || { ip: 'Unknown', city: 'Unknown', state: 'Unknown', zip: 'Unknown' }
  }
}

// Fallback to ipstack API for location data
async function ipstackFallback() {
  try {
    const resp = await axios.get(ENDPOINTS.IPSTACK)
    const d = resp.data || {}

    return {
      ip: d.ip || null,
      city: d.city || null,
      state: d.region_code || null,
      zip: d.zip || null
    }
  } catch (e) {
    console.error('Fallback ipstack /check failed:', e)
    return null
  }
}

export const locationService = {
  fetchLocation,
  ipstackFallback
}
